import { render, staticRenderFns } from "./WebsitePostSlides.vue?vue&type=template&id=46b84053"
import script from "./WebsitePostSlides.vue?vue&type=script&lang=js"
export * from "./WebsitePostSlides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports